export default function Input({
  id,
  name,
  placeholder = '',
  value,
  setValue,
  onKeyDown = undefined,
  autoFocus = false,
}: {
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  setValue: any;
  onKeyDown?: any;
  autoFocus?: boolean;
}) {
  return (
    <div className="flex flex-col w-full">
      <label htmlFor={id}>{name}</label>
      <input
        autoFocus={autoFocus}
        placeholder={placeholder}
        id={id}
        value={value}
        onChange={(e: any) => setValue(e.target.value)}
        className="rounded py-2 px-3 border-2 border-orange-500 focus:border-orange-600 focus:outline-none"
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
